import { MessageSquare, FileText, Box, Layers, Activity, ShieldCheck, Factory } from "lucide-react";
import { STAGES } from "@/lib/api";

const ICONS = { intent: MessageSquare, specification: FileText, geometry: Box, materials: Layers, simulation: Activity, validation: ShieldCheck, manufacturing: Factory };

export default function WorkflowDiagram({ activeId, compact = false }) {
  return (
    <div className="w-full">
      <div className="grid grid-cols-7 gap-2 md:gap-3">
        {STAGES.map((s, i) => {
          const Icon = ICONS[s.id];
          const active = s.id === activeId;
          return (
            <div key={s.id} className={`stage-node ${active ? "active" : ""} p-3 md:p-4 flex flex-col items-start gap-2`} data-testid={`stage-${s.id}`}>
              <div className="flex items-center justify-between w-full">
                <span className="font-mono text-[10px] text-[#00D2FF]">0{i + 1}</span>
                <Icon className={`w-4 h-4 ${active ? "text-[#00D2FF]" : "text-slate-400"}`} />
              </div>
              <div className="text-white text-xs md:text-sm font-medium leading-tight">{s.title}</div>
              {!compact && <div className="font-tech">{s.subtitle}</div>}
            </div>
          );
        })}
      </div>
      <div className="dim-line mt-4" />
    </div>
  );
}
